export default __webpack_public_path__ + "static/media/Tannu_Sharma_Design_TeamLead.c9180035.jpeg";